export const dates = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const dateEntries = {
  January: "january",
  February: "february",
  March: "march",
  April: "april",
  May: "may",
  June: "june",
  July: "july",
  August: "august",
  September: "september",
  October: "october",
  November: "november",
  December: "december",
};
